import { Flex } from "Components/_Shared/Core/Flex";
import { ReactComponent as SearchIcon } from "Components/_Shared/Icons/Assets/search.svg";
import { TextInput } from "Components/_Shared/Inputs/TextInput";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useState } from "react";

type Props = {
  onSearch: (value: string) => void;
  onFocus?: () => void;
  useFullWidth?: boolean;
};

export const ClientsSearchInput = ({ onSearch, onFocus, useFullWidth = true }: Props) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { t } = useResource();

  const handleSearch = (term: string) => {
    setSearchTerm(term);

    if (term.length < 2) {
      return;
    }

    onSearch(term);
  };

  return (
    <Flex width={"100%"} justifyContent={useFullWidth ? "center" : "flex-end"} mb={1}>
      <TextInput
        inputStartAdornment={<SearchIcon />}
        placeholder={t(useFullWidth ? Resources.Clients.SearchPlaceholder : Resources.Clients.SearchPlaceholderShort)}
        value={searchTerm}
        autoComplete="off"
        slotProps={{
          htmlInput: {
            "data-bwignore": true,
            "data-1p-ignore": true,
            "data-lpignore": true,
            "data-form-type": "other",
          },
        }}
        onFocus={onFocus}
        sx={{
          width: useFullWidth ? "600px" : "350px",
          "& .MuiInputBase-root": {
            py: useFullWidth ? 2 : 0,
          },
        }}
        onInputChange={(e) => handleSearch(e.target.value)}
      />
    </Flex>
  );
};
